import { Image as ImageType } from "@/types/Image";
import { useEffect, useRef } from "react";
import LeftArrow from "../../icons/LeftArrow";
import ButtonIcon from "../../utils/ButtonIcon";
import Modal from "../../utils/Modal";
import AlbumCarousel from "../AlbumCarousel";
import "./index.scss";

const AlbumCarouselModal = ({
  images,
  initialImageIndex,
  onClose,
}: {
  images: ImageType[];
  initialImageIndex: number;
  onClose: () => void;
}) => {
  const albumCarouselComponentRef = useRef<HTMLUListElement>(null);

  useEffect(() => {
    if (albumCarouselComponentRef && albumCarouselComponentRef.current) {
      const imageListNode = albumCarouselComponentRef.current;
      if (imageListNode) {
        const componentWidth = imageListNode.clientWidth;
        imageListNode.scroll(initialImageIndex * componentWidth, 0);
      }
    }
  }, []);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        onClose();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [onClose]);

  return (
    <Modal>
      <div className="component album-carousel-modal">
        <div className="modal-header">
          <ButtonIcon onClick={onClose} aria-label="Close">
            <LeftArrow />
          </ButtonIcon>
        </div>
        <div className="modal-body">
          <AlbumCarousel
            images={images}
            ref={albumCarouselComponentRef}
            sizes="100vw"
            objectFit="contain"
            arrowPosition="outside"
          />
        </div>
      </div>
    </Modal>
  );
};

export default AlbumCarouselModal;
